import { jsx, Fragment } from "react/jsx-runtime";
import { isValidElement } from "react";
import { P } from "../foundations/typography/Text/Text.js";
const alert = "_alert_tobj0_1";
const alertMain = "_alertMain_tobj0_17";
const alertTitle = "_alertTitle_tobj0_24";
const alertContent = "_alertContent_tobj0_25";
const styles = {
  alert,
  alertMain,
  alertTitle,
  alertContent,
  "alert-info": "_alert-info_tobj0_33",
  "alert-warning": "_alert-warning_tobj0_39",
  "alert-error": "_alert-error_tobj0_45",
  "alert-success": "_alert-success_tobj0_52"
};
const AlertContent = ({ children }) => {
  if (typeof children === "string") {
    return /* @__PURE__ */ jsx(P, { variant: "text-body", className: styles.alertContent, children });
  }
  if (Array.isArray(children)) {
    const allStringsOrNumbers = children.every(
      (child) => typeof child === "string" || typeof child === "number"
    );
    if (allStringsOrNumbers) {
      return /* @__PURE__ */ jsx(Fragment, { children: children.map((child, index) => /* @__PURE__ */ jsx(P, { variant: "text-body", className: styles.alertContent, children: child }, `alert-${index}`)) });
    } else {
      return /* @__PURE__ */ jsx(Fragment, { children });
    }
  }
  if (isValidElement(children)) {
    return children;
  }
  return null;
};
export {
  AlertContent as A,
  styles as s
};
